import { API_URL, getCachedSessionId } from 'src/services/common';
import { CreateCustomTypeResponseData } from './interfaces/createCustomTypeData.interface';
import { CustomType } from '../interfaces/fetchCustomTypes.interface';
import { api } from '../../../../util/axios-instance';

export const createCustomType = async (
  projectId: string,
  customType: CustomType
): Promise<CreateCustomTypeResponseData | undefined> => {
  const response = await api.post<CreateCustomTypeResponseData>(
    `${API_URL}/v1/project/${projectId}/customType`,
    customType,
    {
      headers: { 'x-session-id': getCachedSessionId() }
    }
  );
  return response.data;
};
